import { render, staticRenderFns } from "./data-processing-card.vue?vue&type=template&id=7dfddfa5&scoped=true"
import script from "./data-processing-card.vue?vue&type=script&lang=js"
export * from "./data-processing-card.vue?vue&type=script&lang=js"
import style0 from "./data-processing-card.vue?vue&type=style&index=0&id=7dfddfa5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dfddfa5",
  null
  
)

export default component.exports